export default __webpack_public_path__ + "static/media/Versions - Comparisons - Layouts.eee53238.mp4";